import { ComponentProps } from "react";
import { Button } from "../../button";
import "./already-subscribed.scss";
import { useAppSelector } from "../../../../hooks/hooks";
import {
  selectLanguage,
  selectTranslations,
} from "../../../data-access/store/general/generalSlice";
import { checkTranslationKey } from "../../../../utils/translation";

export interface AlreadySubscribedProps extends ComponentProps<"div"> {
  onButtonClick: () => void;
  buttonText?: string;
}

export function AlreadySubscribed({
  onButtonClick,
  buttonText,
  ...props
}: AlreadySubscribedProps) {
  const lang = useAppSelector(selectLanguage);
  const translations = useAppSelector(selectTranslations);

  return (
    <div className="already-subscribed-modal modal-content" {...props}>
      <div className="top-area">
        <div className="title">
          {checkTranslationKey(
            translations[lang]?.Already_subscribed,
            "Already subscribed!"
          )}
        </div>
        <div className="message-icon">
          <img src="../img/icns/already-subscribed.png" alt="" width="80em" />
        </div>
        <div className="message">
          {checkTranslationKey(
            translations[lang]?.You_have_already_subscribed_to_BattleUp,
            "You have already subscribed to BattleUp."
          )}
        </div>
      </div>
      <div className="bottom-area">
        <Button onClick={onButtonClick} buttonType="success">
          {buttonText ||
            checkTranslationKey(translations[lang]?.Play_now, "Play now")}
        </Button>
      </div>
    </div>
  );
}

export default AlreadySubscribed;
